// Globals
import { Form, Modal } from 'antd';
import { useCallback, useEffect, useMemo } from 'react';

// Components
import { UserDataForm } from '../../components';
import { StyledSubtitle, StyledTitle, StyledWrapper } from './UserDataContainerStyles';

// Helpers
import {
  getIdentificationVariantKey,
  getUserDataFormInitialValues,
  IDENTIFICATION_VARIANTS,
  IdentificationVariant,
  TUserDataFormValues
} from '../../helpers';

// Models
import { TIdentificationRequestPrefill } from '@/models/chat.model';

type TUserDataFormProps = {
  onCancel?: () => void
  open?: boolean
  loading?: boolean
  saveUserData?: (data: TUserDataFormValues) => void
  userInfo?: TIdentificationRequestPrefill | null
}

export const UserDataContainer = ({ onCancel, open, loading, saveUserData, userInfo }: TUserDataFormProps) => {
  const [form] = Form.useForm<TUserDataFormValues>();
  const initialValues = useMemo(() => getUserDataFormInitialValues(userInfo), [userInfo]);
  const variantKey = useMemo(() => getIdentificationVariantKey(userInfo), [userInfo]);
  const variant = IDENTIFICATION_VARIANTS[variantKey];

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue(initialValues);
  }, [form, initialValues, open]);

  const handleSave = useCallback((data: TUserDataFormValues) => {
    saveUserData?.(data);
  }, [saveUserData]);

  const handleCancel = () => {
    if (loading) return;
    onCancel?.();
  };

  const handleResetForm = () => {
    form?.resetFields()
  }

  return open && (
    <StyledWrapper>
      <Modal
        open={open}
        onCancel={handleCancel}
        afterClose={handleResetForm}
        footer={null}
        closable
        width={{
          xs: 315,
          xl: 450,
          sm: 450,
          md: 450,
          lg: 450,
          xxl: 450
        }}
        getContainer={false}
        title={
          <StyledTitle>
            <span>
              Швидка підтримка 😎
            </span>
            <StyledSubtitle $error={variantKey !== IdentificationVariant.DEFAULT}>{variant.subtitle}</StyledSubtitle>
          </StyledTitle>
        }
      >
        <UserDataForm form={form} initialValues={initialValues} onSubmit={handleSave} loading={loading} fieldErrors={variant.fieldErrors} />
      </Modal>
    </StyledWrapper >
  );
};
